import React, { useEffect, useRef, useState } from "react";
import "./ImageGrid.scss";

const GridItem = ({ images, index }) => {
  const [isFlipped, setIsFlipped] = useState(false);

  const flipIntervalRef = useRef(null);

  const frontImage = images[0];
  const backImage = images[1] || images[0];

  useEffect(() => {
    if (frontImage !== backImage) {
      flipIntervalRef.current = setInterval(
        () => setIsFlipped((prev) => !prev),
        3000 + Math.random() * 2000
      );
    }

    return () => {
      if (flipIntervalRef.current) {
        clearInterval(flipIntervalRef.current);
      }
    };
  }, [frontImage, backImage]);

  return (
    <div className={`image-grid__item`}>
      <div
        className={`image-grid__item-inner ${isFlipped ? "image-grid__item-inner--flipped" : ""}`}
      >
        <div className="image-grid__item-front">
          <img src={frontImage} alt={`Grid image ${index + 1}`} />
        </div>
        <div className="image-grid__item-back">
          <img src={backImage} alt={`Grid image ${index + 1} alternate`} />
        </div>
      </div>
    </div>
  );
};

const ImageGrid = ({ images, className }) => {
  const getImagesForPosition = (index) => {
    const group = [];

    group.push(images[index]);

    const nextIndex = (index + Math.floor(images.length / 2)) % images.length;

    if (nextIndex !== index) {
      group.push(images[nextIndex]);
    }
    return group;
  };

  return (
    <div className={`image-grid ${className || ""}`}>
      {images.map((_, index) => (
        <GridItem
          key={index}
          images={getImagesForPosition(index)}
          index={index}
        />
      ))}
    </div>
  );
};

export default ImageGrid;
